import { isAccountant, isAdmin, sanitizeWoNumber } from "src/Common/function";
import api from "./api";
import UserService from "./user.service";

const getAllWorkOrders = (userId, keyword, pageNumber, criteria, sort, branch) => {
  let currentUser = UserService.getCurrentUser();
  let branchId;
  if (isAdmin() || isAccountant()) {
    branchId = branch;
  } else {
    branchId = currentUser.branches[0].id;
  }
  return api.get("/api/wo/get_all", {
    params: { userId, branchId, keyword, pageNumber, criteria, sort },
  });
};

const getAllOrderNumber = (branch) => {
  let currentUser = UserService.getCurrentUser();
  let branchId = branch;
  if (!isAdmin()) {
    branchId = currentUser.branches[0].id;
  }
  return api.get("/api/wo/getAllOrderNumber", { params: { branchId } });
};

const getAllRecommendations = (keyword, pageNumber, branch) => {
  let currentUser = UserService.getCurrentUser();
  let branchId = branch;
  if (!isAdmin()) {
    branchId = currentUser.branches[0].id;
  }
  return api.get("/api/wo/get_recommendations", { params: { keyword, pageNumber, branchId } });
};

const createWorkOrder = (data) => {
  return api.post("/api/wo/create_wo", data);
};

const getWorkOrderById = (id) => {
  return api.get("/api/wo/getById", { params: { id } });
};

const getWorkOrderByNumber = (number) => {
  return api.get("/api/wo/getByNumber", { params: { number } });
};

const update = (data) => {
  return api.post("/api/wo/update", data);
};

const uploadFiles = (files, orderId, type, currentUser) => {
  const formData = new FormData();
  formData.append("orderId", orderId);
  formData.append("type", type);
  formData.append("userId", currentUser.id);
  for (let file of files) {
    formData.append("files", file);
  }

  return api.post("/api/wo/attach", formData, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

const updateAttachment = (data) => {
  return api.post("/api/wo/update_attachment", data);
};

const attachMaterials = (data) => {
  return api.post("/api/wo/attach_materials", data);
};

const updateMaterial = (woID, index, data, eventUser) => {
  return api.post("/api/wo/update_material", { woID, index, data, eventUser });
};

const previewServiceTicket = (woId) => {
  return api.get("/api/wo/preview_serviceticket", { params: { id: woId } });
};

const sendServiceTicket = (woId) => {
  return api.get("/api/wo/send_serviceticket", {
    params: { id: woId, stSentDate: new Date() },
  });
};

const deleteById = (id) => {
  return api.get("/api/wo/deleteByID", { params: { id } });
};

const deleteAttachment = (woId, attachmentId, type) => {
  return api.get("/api/wo/delete_attachment", { params: { woId, attachmentId, type } });
};

const generateExcelFile = (userId, keyword, criteria, sort, branch) => {
  let currentUser = UserService.getCurrentUser();
  let branchId = branch;
  if (!isAdmin()) {
    branchId = currentUser.branches[0].id;
  }
  return api.get("/api/wo/generate_excel_file", { params: { userId, branchId, keyword, criteria, sort } });
};

const getAllOrderNumberWithKeyword = (keyword, branch) => {
  let currentUser = UserService.getCurrentUser();
  let branchId = branch;
  if (!isAdmin() && !isAccountant()) {
    branchId = currentUser.branches[0].id;
  }
  return api.get("/api/wo/getAllOrderNumberWithKeyword", { params: { keyword, branchId } });
};

const getWOsForCalendar = (view, year, month, weekNumber, branch) => {
  return api.get("/api/wo/get_wos_for_calendar", { params: { view, year, month, weekNumber, branch } });
};

const checkWONumberDuplicate = (number) => {
  return api.get("/api/wo/check_wo_number_duplicate", { params: { number: sanitizeWoNumber(number) } });
};

const WOService = {
  checkWONumberDuplicate,
  createWorkOrder,
  getAllWorkOrders,
  sendServiceTicket,
  previewServiceTicket,
  attachMaterials,
  getWorkOrderById,
  getWorkOrderByNumber,
  uploadFiles,
  update,
  deleteById,
  updateMaterial,
  getAllRecommendations,
  getAllOrderNumber,
  deleteAttachment,
  generateExcelFile,
  getAllOrderNumberWithKeyword,
  getWOsForCalendar,
  updateAttachment,
};

export default WOService;
